/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateSocialPostCommandResult } from '../model/createSocialPostCommandResult';
import { DeleteSocialPostCommandResult } from '../model/deleteSocialPostCommandResult';
import { GetSharedEstatesQueryResult } from '../model/getSharedEstatesQueryResult';
import { GetSocialFeedQueryResult } from '../model/getSocialFeedQueryResult';
import { GetSocialFollowsQueryResult } from '../model/getSocialFollowsQueryResult';
import { InlineResponse404 } from '../model/inlineResponse404';
import { ManageSocialFollowsCommand } from '../model/manageSocialFollowsCommand';
import { MarkSocialPostReadCommandResult } from '../model/markSocialPostReadCommandResult';
import { ToggleSocialPostLikeCommandResult } from '../model/toggleSocialPostLikeCommandResult';
import { VideoFormat } from '../model/videoFormat';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SocialFeedService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param userUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public socialFeedFollowsGet(userUid?: string, observe?: 'body', reportProgress?: boolean): Observable<GetSocialFollowsQueryResult>;
    public socialFeedFollowsGet(userUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetSocialFollowsQueryResult>>;
    public socialFeedFollowsGet(userUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetSocialFollowsQueryResult>>;
    public socialFeedFollowsGet(userUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (userUid !== undefined && userUid !== null) {
            queryParameters = queryParameters.set('UserUid', <any>userUid);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetSocialFollowsQueryResult>('get',`${this.basePath}/SocialFeed/Follows`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public socialFeedFollowsPut(body?: ManageSocialFollowsCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public socialFeedFollowsPut(body?: ManageSocialFollowsCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public socialFeedFollowsPut(body?: ManageSocialFollowsCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public socialFeedFollowsPut(body?: ManageSocialFollowsCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/SocialFeed/Follows`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param pageNumber 
     * @param pageSize 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public socialFeedGet(pageNumber?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<GetSocialFeedQueryResult>;
    public socialFeedGet(pageNumber?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetSocialFeedQueryResult>>;
    public socialFeedGet(pageNumber?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetSocialFeedQueryResult>>;
    public socialFeedGet(pageNumber?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', <any>pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetSocialFeedQueryResult>('get',`${this.basePath}/SocialFeed`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param text 
     * @param file 
     * @param link 
     * @param videoFormat 
     * @param postOnBehalfOfUserUid 
     * @param isCompanyPost 
     * @param referencedPostUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public socialFeedPostForm(text?: string, file?: Blob, link?: string, videoFormat?: VideoFormat, postOnBehalfOfUserUid?: string, isCompanyPost?: boolean, referencedPostUid?: string, observe?: 'body', reportProgress?: boolean): Observable<CreateSocialPostCommandResult>;
    public socialFeedPostForm(text?: string, file?: Blob, link?: string, videoFormat?: VideoFormat, postOnBehalfOfUserUid?: string, isCompanyPost?: boolean, referencedPostUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateSocialPostCommandResult>>;
    public socialFeedPostForm(text?: string, file?: Blob, link?: string, videoFormat?: VideoFormat, postOnBehalfOfUserUid?: string, isCompanyPost?: boolean, referencedPostUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateSocialPostCommandResult>>;
    public socialFeedPostForm(text?: string, file?: Blob, link?: string, videoFormat?: VideoFormat, postOnBehalfOfUserUid?: string, isCompanyPost?: boolean, referencedPostUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (text !== undefined) {
            formParams = formParams.append('Text', <any>text) as any || formParams;
        }
        if (file !== undefined) {
            formParams = formParams.append('File', <any>file) as any || formParams;
        }
        if (link !== undefined) {
            formParams = formParams.append('Link', <any>link) as any || formParams;
        }
        if (videoFormat !== undefined) {
            formParams = formParams.append('VideoFormat', <any>videoFormat) as any || formParams;
        }
        if (postOnBehalfOfUserUid !== undefined) {
            formParams = formParams.append('PostOnBehalfOfUserUid', <any>postOnBehalfOfUserUid) as any || formParams;
        }
        if (isCompanyPost !== undefined) {
            formParams = formParams.append('IsCompanyPost', <any>isCompanyPost) as any || formParams;
        }
        if (referencedPostUid !== undefined) {
            formParams = formParams.append('ReferencedPostUid', <any>referencedPostUid) as any || formParams;
        }

        return this.httpClient.request<CreateSocialPostCommandResult>('post',`${this.basePath}/SocialFeed`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param brokerUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public socialFeedSharedEstatesGet(brokerUid?: string, observe?: 'body', reportProgress?: boolean): Observable<GetSharedEstatesQueryResult>;
    public socialFeedSharedEstatesGet(brokerUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetSharedEstatesQueryResult>>;
    public socialFeedSharedEstatesGet(brokerUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetSharedEstatesQueryResult>>;
    public socialFeedSharedEstatesGet(brokerUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (brokerUid !== undefined && brokerUid !== null) {
            queryParameters = queryParameters.set('BrokerUid', <any>brokerUid);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetSharedEstatesQueryResult>('get',`${this.basePath}/SocialFeed/SharedEstates`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public socialFeedUidDelete(uid: string, observe?: 'body', reportProgress?: boolean): Observable<DeleteSocialPostCommandResult>;
    public socialFeedUidDelete(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeleteSocialPostCommandResult>>;
    public socialFeedUidDelete(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeleteSocialPostCommandResult>>;
    public socialFeedUidDelete(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling socialFeedUidDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DeleteSocialPostCommandResult>('delete',`${this.basePath}/SocialFeed/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public socialFeedUidLikePost(uid: string, observe?: 'body', reportProgress?: boolean): Observable<ToggleSocialPostLikeCommandResult>;
    public socialFeedUidLikePost(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ToggleSocialPostLikeCommandResult>>;
    public socialFeedUidLikePost(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ToggleSocialPostLikeCommandResult>>;
    public socialFeedUidLikePost(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling socialFeedUidLikePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ToggleSocialPostLikeCommandResult>('post',`${this.basePath}/SocialFeed/${encodeURIComponent(String(uid))}/Like`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param text 
     * @param file 
     * @param link 
     * @param videoFormat 
     * @param removeMedia 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public socialFeedUidPutForm(uid: string, text?: string, file?: Blob, link?: string, videoFormat?: VideoFormat, removeMedia?: boolean, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public socialFeedUidPutForm(uid: string, text?: string, file?: Blob, link?: string, videoFormat?: VideoFormat, removeMedia?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public socialFeedUidPutForm(uid: string, text?: string, file?: Blob, link?: string, videoFormat?: VideoFormat, removeMedia?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public socialFeedUidPutForm(uid: string, text?: string, file?: Blob, link?: string, videoFormat?: VideoFormat, removeMedia?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling socialFeedUidPut.');
        }






        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (text !== undefined) {
            formParams = formParams.append('Text', <any>text) as any || formParams;
        }
        if (file !== undefined) {
            formParams = formParams.append('File', <any>file) as any || formParams;
        }
        if (link !== undefined) {
            formParams = formParams.append('Link', <any>link) as any || formParams;
        }
        if (videoFormat !== undefined) {
            formParams = formParams.append('VideoFormat', <any>videoFormat) as any || formParams;
        }
        if (removeMedia !== undefined) {
            formParams = formParams.append('RemoveMedia', <any>removeMedia) as any || formParams;
        }

        return this.httpClient.request<any>('put',`${this.basePath}/SocialFeed/${encodeURIComponent(String(uid))}`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public socialFeedUidReadPost(uid: string, observe?: 'body', reportProgress?: boolean): Observable<MarkSocialPostReadCommandResult>;
    public socialFeedUidReadPost(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MarkSocialPostReadCommandResult>>;
    public socialFeedUidReadPost(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MarkSocialPostReadCommandResult>>;
    public socialFeedUidReadPost(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling socialFeedUidReadPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MarkSocialPostReadCommandResult>('post',`${this.basePath}/SocialFeed/${encodeURIComponent(String(uid))}/Read`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
